module.exports = __webpack_public_path__ + "static/media/close_icon.1614452f.png";